$('.trusted-grid-slider').slick({
  dots: true,
  infinite: true,
  arrows: false,
  centerMode: true,
  centerPadding: '125px',
  slidesToShow: 3,
  adaptiveHeight: true,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1
      }
    }
  ]
});